<template>
  <div class="chatSetting">
    <pageTitle :pageTitle="$t('lang.k_345001')"></pageTitle>
    <div class="chatSettingContainer">
      <vh-tabs v-model="tabType">
        <vh-tab-pane :label="$t('lang.k_345002')" name="forbiddenWord">
          <ForbiddenWord v-if="tabType == 'forbiddenWord'"></ForbiddenWord>
        </vh-tab-pane>
        <vh-tab-pane name="kickOut">
          <span slot="label">
            {{ $t('lang.k_345003') }}
            <vh-tooltip effect="dark" placement="right" v-tooltipMove>
              <div slot="content">
                <div class="text">
                  <p>{{ $t('lang.k_345004') }}</p>
                  <p>{{ $t('lang.k_345005') }}</p>
                </div>
              </div>
              <i class="iconfont-v3 saasicon_help_m"></i>
            </vh-tooltip>
          </span>
          <KickOut v-if="tabType == 'kickOut'"></KickOut>
        </vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_345006')" name="pushMsg" v-if="chat_msg_push_third == 1">
          <PushMsg v-if="tabType == 'pushMsg'"></PushMsg>
        </vh-tab-pane>
        <vh-tab-pane name="hidechat">
          <span slot="label">
            {{ $t('lang.k_345007') }}
            <vh-tooltip effect="dark" placement="right" v-tooltipMove>
              <div slot="content">
                <div class="text">
                  <p>{{ $t('lang.k_345008') }}</p>
                  <p>{{ $t('lang.k_345009') }}</p>
                  <p>{{ $t('lang.k_345010') }}</p>
                </div>
              </div>
              <i class="iconfont-v3 saasicon_help_m"></i>
            </vh-tooltip>
          </span>
          <section class="chat_hide_banned">
            <vh-form v-if="tabType == 'hidechat'" class="hidechat">
              <vh-form-item :label="$t('lang.k_345011')">
                <p class="switch__box">
                  <vh-switch
                    v-model="globalChatConfig.global_chat_hide"
                    active-color="#ff4949"
                    inactive-color="#ccc"
                    @change="saveGlobalConfig"
                    active-value="1"
                    inactive-value="0"
                    :active-text="hideChatStr"
                  ></vh-switch>
                </p>
              </vh-form-item>
              <vh-form-item :label="$t('lang.k_345012')">
                <p class="switch__box">
                  <vh-switch
                    v-model="globalChatConfig.global_banned"
                    active-color="#ff4949"
                    inactive-color="#ccc"
                    active-value="1"
                    inactive-value="0"
                    @change="saveGlobalConfig"
                    :active-text="bannedAllStr"
                  ></vh-switch>
                </p>
              </vh-form-item>
            </vh-form>
            <div class="preview">
              <!-- 模拟开关 -->
              <div class="zdy--switch">
                <span
                  :class="switchType === 'app' ? 'active' : ''"
                  @click.prevent.stop="switchType = 'app'"
                >
                  {{ $t('lang.k_345013') }}
                </span>
                <span
                  :class="switchType === 'pc' ? 'active' : ''"
                  @click.prevent.stop="switchType = 'pc'"
                >
                  {{ $t('lang.k_345014') }}
                </span>
              </div>
              <!--PC预览,begin-->
              <div v-show="switchType === 'pc'" class="pc_preivew">
                <span class="chat-span" v-if="globalChatConfig.global_chat_hide != 1">
                  {{
                    globalChatConfig.global_banned == 1 ? $t('lang.k_345015') : $t('lang.k_345016')
                  }}
                </span>
                <img
                  :src="
                    globalChatConfig.global_chat_hide == 1
                      ? require('../../common/images/plan-function/pc-hidechat.png')
                      : require('../../common/images/plan-function/pc-dafault2.png')
                  "
                  alt=""
                />
              </div>
              <!--手机预览,begin-->
              <div v-show="switchType === 'app'" class="app_preivew">
                <span class="chat-span" v-if="globalChatConfig.global_chat_hide != 1">
                  {{
                    globalChatConfig.global_banned == 1 ? $t('lang.k_345015') : $t('lang.k_345016')
                  }}
                </span>
                <img
                  :src="
                    globalChatConfig.global_chat_hide == 1
                      ? require('../../common/images/plan-function/phone-chathide.png')
                      : require('../../common/images/plan-function/phone-default.png')
                  "
                  alt=""
                />
              </div>
            </div>
          </section>
        </vh-tab-pane>
        <vh-tab-pane name="auditSet" :label="$t('lang.k_345017')">
          <AuditSet v-if="tabType == 'auditSet'"></AuditSet>
        </vh-tab-pane>
      </vh-tabs>
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import ForbiddenWord from './ForbiddenWord/Index.vue';
  import KickOut from './kickOut.vue';
  import PushMsg from './pushMsg.vue';
  import AuditSet from './auditSet.vue';

  export default {
    name: 'chatMgr',
    components: {
      PageTitle,
      ForbiddenWord,
      KickOut,
      PushMsg,
      AuditSet
    },
    data() {
      return {
        tabType: 'forbiddenWord',
        chat_msg_push_third: 0,
        globalChatConfig: {
          global_chat_hide: '0',
          global_banned: '0'
        },
        switchType: 'app'
      };
    },
    computed: {
      hideChatStr() {
        return this.globalChatConfig.global_chat_hide == '1'
          ? this.$t('lang.k_345018')
          : this.$t('lang.k_345019');
      },
      bannedAllStr() {
        return this.globalChatConfig.global_banned == '1'
          ? this.$t('lang.k_345020')
          : this.$t('lang.k_345021');
      }
    },
    mounted() {
      this.getGlobalConfig();
    },
    methods: {
      getGlobalConfig() {
        this.$fetch('getGeneralConfig', {
          type: 'global_chat_banned'
        }).then(res => {
          if (res.code == 200) {
            res.data.content && (this.globalChatConfig = JSON.parse(res.data.content));
          }
        });
      },
      saveGlobalConfig() {
        this.$fetch('saveGeneralConfig', {
          type: 'global_chat_banned',
          content: JSON.stringify(this.globalChatConfig)
        })
          .then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('lang.k_345022'));
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      }
    },
    created() {
      const permission = JSON.parse(localStorage.getItem('SAAS_VS_PES'));
      this.chat_msg_push_third = permission['chat_msg_push_third'];
    },
    beforeDestroy() {}
  };
</script>

<style lang="less" scoped>
  .chatSettingContainer {
    background-color: #fff;
  }
  .chat_hide_banned {
    display: flex;
    .hidechat {
      min-height: 600px;
      padding: 30px;
      flex: 1;
    }
    .preview {
      width: 400px;
      img {
        width: 400px;
        margin: 0 auto;
      }
      .pc_preivew {
        position: relative;
        .chat-span {
          position: absolute;
          color: #999;
          font-size: 12px;
          left: 286px;
          bottom: 31px;
          transform-origin: top left;
          transform: scale(0.5);
        }
      }
      .app_preivew {
        position: relative;
        img {
          width: 300px;
        }
        .chat-span {
          position: absolute;
          bottom: 46px;
          font-size: 10px;
          color: #999;
          left: 58px;
        }
      }
    }
  }
</style>
<style lang="less">
  .chatSettingContainer {
    .vh-tabs__content {
      padding: 0 20px 20px;
    }
  }
</style>
